export const asInsightArray = (value, fallback = []) =>
  Array.isArray(value) && value.length > 0 ? value : fallback;

/** Normalize assorted insight row shapes into InterventionActionPlan fallback lines. */
export const toInsightLine = (item) => {
  if (!item) return "";
  if (typeof item === "string") return item.trim();

  const title = item.title || item.headline || item.label || item.theme || "";
  const body =
    item.text ||
    item.body ||
    item.description ||
    item.action ||
    item.signal ||
    item.detail ||
    "";

  if (title && body && title !== body) return `${title}: ${body}`;
  return String(title || body || "").trim();
};

export const toInsightLines = (items = []) =>
  (Array.isArray(items) ? items : []).map(toInsightLine).filter(Boolean);

export const cardsToInsightLines = (cards = []) => toInsightLines(cards);

export const registerToInsightLines = (rows = []) =>
  rows
    .map((row) => {
      if (typeof row === "string") return row;
      const parts = [row.theme, row.signal, row.action].filter(Boolean);
      return parts.length ? parts.join(" — ") : toInsightLine(row);
    })
    .filter(Boolean);
